import { useDeviationSubscription } from '../../../../../hooks/useDeviationSubscription';
import { useDeviationAlertsSummaryQuery } from './useDeviationAlertsSummaryQuery';
import { useDeviationAlertsQuery } from './useDeviationAlertsQuery';
export const useDeviationAlertsSummarySubscription = (widgetType) => {
    const { refetch, data, isLoading } = useDeviationAlertsSummaryQuery(widgetType);
    const { refetch: refetchAlerts } = useDeviationAlertsQuery(widgetType);
    useDeviationSubscription(widgetType, refetch);
    useDeviationSubscription(widgetType, refetchAlerts);
    return { data, isLoading };
};
//# sourceMappingURL=useDeviationAlertsSummarySubscription.js.map